<template>
  <div class="event">
    <Event msg="Event"/>
  </div>
</template>

<script>
  // @ is an alias to /src
  import Event from '@/components/Event.vue';

  export default {
    name: 'event',
    components: {
      Event,
    },
  };
</script>
